var qs = (function (a) {
  if (a == "") return {};
  var b = {};
  for (var i = 0; i < a.length; ++i) {
    var p = a[i].split("=", 2);
    if (p.length == 1) b[p[0]] = "";
    else b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, " "));
  }
  return b;
})(window.location.search.substr(1).split("&"));

// for record source users
if (qs["_deeper_users"]) {
  var from = qs["_deeper_users"];
  window.localStorage.setItem("$$from$$", from || "");
}

function _set_var(key, value) {
  if (value) {
    var queryData = value;
    window.localStorage.setItem("$$" + key + "$$", queryData || "");
    //     window[key] = queryData;
    Object.assign(window, {
      [key]: queryData,
    });
  } else {
    if (window.localStorage.getItem("$$" + key + "$$")) {
      //       window[key] = window.localStorage.getItem('$$'+key+'$$');
      Object.assign(window, {
        [key]: window.localStorage.getItem("$$" + key + "$$"),
      });
    }
  }
}

_set_var("gb_utm_source", qs["utm_source"]);
_set_var("gb_utm_medium", qs["utm_medium"]);
_set_var("gb_utm_campaign", qs["utm_campaign"]);

function getGa() {
  try {
    var storageGa = window.localStorage.getItem("$$_ga$$");
    var cookieGa = document.cookie
      .split(";")
      .filter((it) => it.match("_ga="))[0]
      .split("=")[1];
    window.gb_ga = cookieGa || storageGa;
    window.localStorage.setItem("$$_ga$$", window.gb_ga);
  } catch (e) {
    window.gb_ga =
      "noGa_" +
      Date.now() +
      "_" +
      String.prototype.slice.apply(Math.random(), [-12]);
    window.localStorage.setItem("$$_ga$$", window.gb_ga);
  }
}

function pageView() {
  var session_id = window.gb_ga;
  var utm_campaign = window.gb_utm_campaign;
  if (!window.gb_ga) {
    session_id = window.location.href;
    utm_campaign = window.navigator.userAgent;
  }

  if (window.location.href.match(/step=payment_method/)) {
    console.log("start payment");
    var email = $("bdo").text();
    var address = $("address").text().replace(/\n/g, "").trim();
    if (email) {
      window.localStorage.setItem("$$email$$", email);
    } else {
      email = window.localStorage.getItem("$$email$$") || "";
    }
    if (address) {
      window.localStorage.setItem("$$address$$", address);
    } else {
      address = window.localStorage.getItem("$$address$$") || "";
    }
  } else if (window.location.href.match(/step=shipping_method/)) {
    console.log("start shipping");
    var email = $("bdo").text();
    var address = $("address").text().replace(/\n/g, "").trim();
    if (email) {
      window.localStorage.setItem("$$email$$", email);
    } else {
      email = window.localStorage.getItem("$$email$$") || "";
    }
    if (address) {
      window.localStorage.setItem("$$address$$", address);
    } else {
      address = window.localStorage.getItem("$$address$$") || "";
    }
  }
  if (window.location.pathname.indexOf("/thank_you") !== -1) {
    try {
      var dataLayerLatest = window.dataLayer.filter(function (it) {
        return it.event == "purchase";
      })[0];
    } catch (e) {
      console.log(e);
    }
  }

  if (window.location.href.match(/checkouts/)) {
    console.log("in checkouts match");
    var storeCouponCode = window.localStorage.getItem("$$couponCode$$");

    if (
      storeCouponCode &&
      storeCouponCode.split("|") &&
      storeCouponCode.split("|")[1]
    ) {
      $(document).on("click", "#checkout_submit", function (e) {
        console.log("click apply coupon");

        var email = $("bdo").text();
        if (email) {
          window.localStorage.setItem("$$email$$", email);
        } else {
          email = window.localStorage.getItem("$$email$$") || "";
        }
      });
    }
  }

  $(document).on("click", "#couponCode", function (e) {
    console.log("click copy coupon");
    var currentCouponCode = $("#couponCode").text();
    // copyToClipboard($('#couponCode').text())
    // selectText("couponCode")
    $("#copiedSpan").remove();
    $("#couponCode").css("position", "relative");
    $("#couponCode").append(
      "<span style='margin: 0 10px;font-weight: bold; position: absolute; bottom: 110%;left: 50%;transform: translateX(-50%);background: #333;border: 1px solid #000;border-radius: 10px;color: #fff;padding: 5px 10px;font-size: 14px;box-shadow: 0 3px 5px #999;' id='copiedSpan'>Copied</span>"
    );
    setTimeout(function () {
      $("#copiedSpan").remove();
    }, 5000);
  });
  $(document).on("click", ".navlink--cart", function (e) {
    console.log("click cart link");
    couponCheck();
  });
  if (window.location.href.match(/\/cart/)) {
    console.log("open cart link");
    couponCheck();
  }
}

function showCouponModal(code, email) {
  console.log("showCoupon");
  console.log(code, email);
  if (!code) {
    return;
  }
  var codeData = code.split("|");
  if (!codeData[1]) {
    window.localStorage.setItem("$$couponCode$$", "");
    return;
  }

  $("#couponOff").text(codeData[1]);
  $("#couponCode").text(codeData[0]);
  $("#couponBox").show();
}

function couponCheck() {
  //   console.log('close coupon check')
  //   return
  console.log("start coupon check");
  var email = $("bdo").text();
  if (email) {
    window.localStorage.setItem("$$email$$", email);
  } else {
    email = window.localStorage.getItem("$$email$$") || "";
  }

  //   var storeCouponCode = window.localStorage.getItem('$$couponCode$$')
  //   if (storeCouponCode) {
  //     showCouponModal(storeCouponCode, email)
  //     return
  //   }

  if (location.href.indexOf("cooling-base") === -1) {
    setTimeout(function () {
      $("#couponBox").show();
    }, 3000);
  } else {
    $("#couponBox").hide();
  }
}

getGa();

$(function () {
  getGa();
  pageView();
  if (window.location.href.split("#").length === 2) {
    setTimeout(function () {
      if (window.location.href.split("#")[1]) {
        // document.querySelector("[id="+window.location.href.split('#')[1]+"]").scrollIntoView(true);

        window.scrollTo({
          behavior: "smooth",
          top:
            document
              .querySelector("[id=" + window.location.href.split("#")[1] + "]")
              .getBoundingClientRect().top -
            document.body.getBoundingClientRect().top -
            40,
        });
      }
    }, 500);
  }
});

function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i].trim();
    if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
  }
  return "";
}

function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toGMTString();
  document.cookie = cname + "=" + cvalue + "; " + expires;
}

function listenCookieChange(key, callback, interval = 1000) {
  let lastCookie = getCookie(key);
  setInterval(() => {
    let cookie = getCookie(key);
    if (cookie !== lastCookie) {
      try {
        callback({ oldValue: lastCookie, newValue: cookie });
      } finally {
        lastCookie = cookie;
      }
    }
  }, interval);
}

listenCookieChange(
  "discount_code",
  ({ oldValue, newValue }) => {
    console.log(`Cookie changed from "${oldValue}" to "${newValue}"`);
    var codes = oldValue.split("+%7C+");
    codes.push(newValue);
    setCookie("localcoupons", Array.from(new Set(codes)).join(","), 1);
  },
  1000
);

$(function () {
  $(".talk-from-selector").on("click", "li", function () {
    var from = $(this).text();
    $(".talkfromSelected").removeClass("talkfromSelected");
    $(this).addClass("talkfromSelected");

    $(".collection-grid-talking-aboutus").addClass("hide");
    $("#talking-aboutus-" + from).removeClass("hide");
  });

  $(".faq-selector").on("click", "li", function () {
    var from = $(this).text();
    if (from === "Troubleshooting") {
      from = "Function_Feature";
    }

    if (from === "DPN") {
      from = "DPN";
    }

    if (from === "Charges and Fees") {
      from = "Charges_and_Fees";
    }

    if (from === "Security Concerns") {
      from = "Security_Concerns";
    }

    $(".faqSelected").removeClass("faqSelected");
    $(this).addClass("faqSelected");
    $(".faq-grid div").css("display", "none");
    $("#faq-" + from).css("display", "block");
  });

  $(".faq-grid li h3").on("click", function () {
    $(this).parent().find("p").fadeToggle("slow");
    $(this).toggleClass("showed");
    // $(this).find('p').fadeToggle("slow");
  });

  $(".deeper-faq-grid li h3").on("click", function () {
    $(this).parent().find(".content").fadeToggle("slow");
    $(this).toggleClass("showed");
    // $(this).find('p').fadeToggle("slow");
  });

  $(".product-faq__selector").on("click", "li", function () {
    var from = $(this).text();
    if (from === "Troubleshooting") {
      from = "Function_Feature";
    }

    if (from === "DPN") {
      from = "DPN";
    }

    if (from === "Charges and Fees") {
      from = "Charges_and_Fees";
    }

    if (from === "Security Concerns") {
      from = "Security_Concerns";
    }

    $(".selected").removeClass("selected");
    $(this).addClass("selected");
    $(".product-faq__grid div").css("display", "none");
    $("#faq-" + from).css("display", "block");
  });

  $(".product-faq__grid li h3").on("click", function () {
    $(this).parent().find("p").fadeToggle("slow");
    $(this).toggleClass("showed");
    // $(this).find('p').fadeToggle("slow");
  });
});

function toggleContent(toggleLinkId, contentToManipulateClass) {
  var $toggleLink = $("#" + toggleLinkId);
  var $contentToManipulate = $("." + contentToManipulateClass);
  if ($toggleLink.length > 0 && $contentToManipulate.length > 0) {
    $toggleLink.click(function (e) {
      e.preventDefault(); // 阻止默认动作，比如链接的跳转
      $toggleLink.fadeOut(function () {
        $contentToManipulate.fadeIn();
      });
    });
  }
}
toggleContent(
  "why-did-the-ads-filter-not-work-learn-more",
  "why-did-the-ads-filter-not-work-more"
);
toggleContent(
  "why-am-i-still-using-the-real-ip-learn-more",
  "why-am-i-still-using-the-real-ip-more"
);
toggleContent(
  "cybersecurity-risks-to-bandwidth-providers-learn-more",
  "cybersecurity-risks-to-bandwidth-providers-more"
);
toggleContent(
  "what-are-the-notable-differences-in-user-experience-between-dpn-and-vpn-learn-more",
  "what-are-the-notable-differences-in-user-experience-between-dpn-and-vpn-more"
);

toggleContent(
  "deeper-features-apps-relocator-learn-more",
  "deeper-features-apps-relocator-more"
);
toggleContent(
  "geo-unlock-solution-video-learn-more",
  "geo-unlock-solution-video-more"
);
